<div class="page-wrapper">
  <footer>
    <div class="container">
      <div class="footer_info">
        <a href=""><img src="./assets/images/footer-logo.svg" alt="" class="img-fluid" /></a>

        <ul class="list-group">
          <li class="list-group-item text-white">
            <div class="list-group-title">Yuklab oling</div>
            <ul class="download_app">
              <li>
                <a href="" class="download_app-link">
                  <div class="item-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="29.016" height="35.491" viewBox="0 0 29.016 35.491">
                      <g id="XMLID_110_" transform="translate(0 0)">
                        <path id="XMLID_138_"
                          d="M288.509,701.152c-2.929,5.169-1.034,13.094,2.24,17.918,1.723,2.412,3.273,4.479,5.685,4.479h.172a5.708,5.708,0,0,0,2.584-.689,7.51,7.51,0,0,1,3.1-.689,6.663,6.663,0,0,1,2.929.689,6.491,6.491,0,0,0,2.757.689c2.584,0,4.135-2.412,5.685-4.479a15.129,15.129,0,0,0,2.412-5h0c0-.172,0-.345-.172-.345h0a7.2,7.2,0,0,1-4.479-6.891,7.411,7.411,0,0,1,3.618-6.375h0l.172-.172v-.172a8.177,8.177,0,0,0-6.547-3.618h-.517a10.448,10.448,0,0,0-4.135,1.034,5.955,5.955,0,0,1-2.068.517,17.816,17.816,0,0,1-2.067-.517,8.01,8.01,0,0,0-3.618-.861h-.172A8.979,8.979,0,0,0,288.509,701.152Z"
                          transform="translate(-287.058 -688.058)" fill="#fff" />
                        <path id="XMLID_116_"
                          d="M302.664,691.6a7.426,7.426,0,0,0-5.341,2.757,7.184,7.184,0,0,0-1.9,5.686c0,.172.172.172.345.172h.345a6.828,6.828,0,0,0,5-2.584,8.284,8.284,0,0,0,1.9-5.858A.534.534,0,0,0,302.664,691.6Z"
                          transform="translate(-281.056 -691.6)" fill="#fff" />
                      </g>
                    </svg>
                  </div>
                  <div class="item-text">
                    <div class="subtitle">Download on the</div>
                    <div class="title">App Store</div>
                  </div>
                </a>
              </li>
              <li>
                <a href="" class="download_app-link">
                  <div class="item-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="34.974" height="38.764" viewBox="0 0 34.974 38.764">
                      <g id="Сгруппировать_71" data-name="Сгруппировать 71" transform="translate(0 0)">
                        <g id="Сгруппировать_70" data-name="Сгруппировать 70">
                          <g id="Сгруппировать_69" data-name="Сгруппировать 69">
                            <g id="Сгруппировать_68" data-name="Сгруппировать 68">
                              <path id="Контур_64" data-name="Контур 64"
                                d="M426.322,703.435l-7.064-4.135-5.858,5.685,5.341,5.169,7.581-4.307a1.45,1.45,0,0,0,.689-1.206A1.744,1.744,0,0,0,426.322,703.435Z"
                                transform="translate(-392.037 -685.517)" fill="#fff" />
                              <path id="Контур_65" data-name="Контур 65"
                                d="M426.509,704.566l-7.753-4.479L401.7,691.3,421,709.907Z"
                                transform="translate(-400.494 -691.3)" fill="#fff" />
                              <path id="Контур_66" data-name="Контур 66"
                                d="M401.8,721.462l16.884-9.131,7.236-4.307-5-4.824Z"
                                transform="translate(-400.422 -682.698)" fill="#fff" />
                              <path id="Контур_67" data-name="Контур 67" d="M401,691.7v37.731l19.468-18.951Z"
                                transform="translate(-401 -691.011)" fill="#fff" />
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>
                  </div>
                  <div class="item-text">
                    <div class="subtitle">Available on the</div>
                    <div class="title">Google Play</div>
                  </div>
                </a>
              </li>
            </ul>
          </li>
          <li class="list-group-item text-white">
            <div class="list-group-title">Aloqa ma'lumotlari:</div>
            <a href="tel:+998712072017" class="phone_icon mb-2">
              +998 (71) 207 20 17
            </a>
            <a href="mailto:info@piima.uz" class="mail_icon mb-2">info&#64;piima.uz</a>
            <span class="location_icon">100170 Toshkent shahri Do'rmon yo'li 34-uy
            </span>
          </li>
          <li class="list-group-item text-white">
            <div class="list-group-title">Ishonch telefoni:</div>

            <a href="tel:+998712072017" class="phone_icon">
              +998 (71) 207 20 17 (100)</a>
            <div>Ishonch telefonini baholash natijasi - 4.5</div>
            <button class="btn btn-more d-block mt-3">Savol yollash</button>
          </li>
        </ul>
      </div>

      <div class="footer_bottom">
        <div class="footer_copyright">
          <i>
            Materialdan to'liq yoki qisman foydalanilganda, piima.uz manbasi
            ko'rsatilishi shart.</i>
          © PIIMA 2025
        </div>

        <div>
          <ul class="footer_social font-thin text-xs">
            <li class="footer_social-item">
              <a href="">
                <span class="col-3">
                  <img src="../../../../assets/icons/banner_facebook.svg" alt="" />
                </span>
                <span class="col-9">"Facebook"dagi sahifa</span>
              </a>
            </li>
            <li class="footer_social-item">
              <a href="">
                <span class="col-3">
                  <img src="../../../../assets/icons/banner_telegram.svg" alt="" /></span>
                <span class="col-9"> "Telegram"dagi kanal</span>
              </a>
            </li>
            <li class="footer_social-item">
              <a href="">
                <span class="col-3">
                  <img src="../../../../assets/icons/banner_email.svg" alt="" /></span>
                <span class="col-9"> Qayta aloqa</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</div>